// Types
import { ILaunchDarklyContext } from "../types/launchdarkly.types";
import { APP_NAMES } from "../types/app";

// Utils
import { decodeString } from "@findemdev/findem-helpers";
import { getAppName } from "./common";

/**
 * Build LaunchDarkly multi-context for feature flag evaluation
 *
 * @param user - User object containing uid, name, email, and accountId
 * @returns LaunchDarkly multi-context object
 */
export const buildLaunchDarklyContext = (
  user: {
    uid: string;
    name: string;
    email: string;
    accountId: string;
  }
): ILaunchDarklyContext => {
  const appName = getAppName();

  return {
    kind: 'multi',
    user: {
      key: decodeString(user.uid),
      name: decodeString(user.name),
      email: decodeString(user.email),
      account_id: decodeString(user.accountId),
      app_name: appName === APP_NAMES.RRA ? 'rra' : 'esp',
    },
    account: {
      key: decodeString(user.accountId),
    }
  };
};
